export const TIMEOUT = 15000;

export const BASE_API_URL = process.env.REACT_APP_BASE_API_URL as string;

export const REVENUECAT_API_URL = 'https://api.revenuecat.com/v1';
